<template>
  <b-modal id="data-consent-modal" ref="modal" title="Data Protection & Privacy Notice" size="lg" scrollable hide-footer>
    <div class="d-flex justify-content-end mb-3">
      <b-button variant="outline-primary" size="sm" @click="downloadPDF" :disabled="isDownloading">
        <b-spinner v-if="isDownloading" small class="me-1"></b-spinner>
        <i v-else class="mdi mdi-download me-1"></i> 
        {{ isDownloading ? 'Generating PDF...' : 'Download PDF' }}
      </b-button>
    </div>

    <!-- Content to be converted to PDF -->
    <div ref="pdfContent" class="pdf-wrapper p-4 bg-white text-dark">
      <div class="text-center mb-4">
        <!-- Logo -->
        <img src="@/assets/images/logo.png" alt="Tandika Logo" height="65" class="mb-3" />
        <h4 class="font-weight-bold">DATA PROTECTION & PRIVACY NOTICE</h4>
      </div>

      <div class="notice-text">
        <h6 class="font-weight-bold text-primary mt-4">1. Who We Are</h6>
        <p>Tandika Technologies provides the digital platform used by your SACCO to manage memberships, savings, and loan services. We act as a data processor on behalf of your SACCO, who is the data controller responsible for your personal data under the Data Protection and Privacy Act.</p>

        <h6 class="font-weight-bold text-primary mt-4">2. What Data We Process on Behalf of Your SACCO</h6>
        <ul>
          <li>Identity details (name, date of birth, national ID number)</li>
          <li>Contact information (phone number, email address, postal address)</li>
          <li>Financial data (savings records, loan history, dividend statements)</li>
          <li>Guarantor information provided during loan applications</li>
          <li>System usage data (login history, transactions performed, features accessed)</li>
        </ul>

        <h6 class="font-weight-bold text-primary mt-4">3. Why We Process Your Data</h6>
        <ul>
          <li>To enable your SACCO to provide membership services</li>
          <li>To process transactions and loan applications</li>
          <li>To deliver system notifications and security alerts</li>
          <li>To generate reports as required by law</li>
          <li>To improve system performance and user experience</li>
        </ul>

        <h6 class="font-weight-bold text-primary mt-4">4. Who We Share Your Data With</h6>
        <p>We share your data only with your SACCO (as the data controller) and with third-party service providers (hosting, analytics) who are contractually bound to protect your data. We do not sell your data to third parties.</p>

        <h6 class="font-weight-bold text-primary mt-4">5. Data Security</h6>
        <p>We implement encryption, access controls, and regular security assessments to protect your data from unauthorised access or loss.</p>

        <h6 class="font-weight-bold text-primary mt-4">6. Data Retention</h6>
        <p>We retain your data for as long as your SACCO requires it to serve your membership, and for any period required by law. Once retention ends, we securely delete or anonymise your data.</p>

        <h6 class="font-weight-bold text-primary mt-4">7. Your Rights</h6>
        <p>You have the right to:</p>
        <ul>
          <li>Withdraw this consent at any time</li>
          <li>Request access to your data</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your data (subject to legal obligations)</li>
        </ul>
        <p>To exercise these rights, contact your SACCO directly.</p>

        <h6 class="font-weight-bold text-primary mt-4">8. International Data Transfers</h6>
        <p>If your data is processed outside Uganda, we ensure adequate safeguards are in place as required by the Data Protection and Privacy Act.</p>
      </div>

      <!-- Version string -->
      <div class="mt-5 text-center text-muted border-top pt-3">
        <small><strong>Version 1.0 2026</strong></small>
      </div>
    </div>
    
    <div class="mt-4 text-right">
      <b-button variant="secondary" @click="hide">Close</b-button>
    </div>
  </b-modal>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'DataConsent',
  data() {
    return {
      isDownloading: false
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    downloadPDF() {
      this.isDownloading = true;
      const element = this.$refs.pdfContent;
      
      const options = {
        margin:       15,
        filename:     'Data_Protection_Privacy_Consent_v1.0.pdf',
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2, useCORS: true }, // useCORS ensures the logo image renders correctly
        jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };

      html2pdf().set(options).from(element).save().then(() => {
        this.isDownloading = false;
      });
    }
  }
};
</script>

<style scoped>
.pdf-wrapper {
  font-family: Arial, sans-serif;
}
.notice-text p, .notice-text ul {
  font-size: 0.92rem;
  color: #495057;
  line-height: 1.6;
  margin-bottom: 0.5rem;
}
.notice-text h6 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
</style>